import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {FILE_FORMATS} from '../../../constants/Lookup';
import download from '../../../util/DownloadLink';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  addMediaTypeStatus: null,
  mediaTypeData: {},
  dropDownData: {},
  systemNotesStatus: null,
  userMetrix: '',
  addSuccessMsg: null,
  addRecordData: {},
  addMediaStatus: null,
  isSystemNoteLoading: null,
  usageMedial: {},
  mediaTypePrintStatus: null,
};

const slice = createSlice({
  name: 'addMediaType',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNoteStart: (state) => {
      state.isSystemNoteLoading = true;
      state.errorMsg = null;
    },
    postMediaTypeData: (state, action) => {
      state.addMediaStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.userMetrix = action.payload.response.userMetrix;
    },
    postMediaTypeAddData: (state, action) => {
      state.addMediaTypeStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.addRecordData = action.payload.response.placeResponse;
      state.addSuccessMsg = action.payload.message;
      state.userMetrix = action.payload.response.userMetrix;
    },
    postSystemNotesData: (state, action) => {
      state.systemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.isSystemNoteLoading = false;
    },
    getMediaTypeData: (state, action) => {
      state.mediaTypeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    getMediaTypeUsageData: (state, action) => {
      state.usageMedial = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    setMediaTypePrintData: (state, action) => {
      state.isLoading = false;
      state.mediaTypePrintStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    resetMediaUsagedata: (state) => {
      state.usageMedial = {};
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
      state.isSystemNoteLoading = false;
    },
    fetchAddSuccess: (state, action) => {
      state.addSuccessMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
      state.isSystemNoteLoading = false;
    },
    resetStatus: (state, action) => {
      state.addMediaTypeStatus = null;
      state.addMediaStatus = null;
      state.isLoading = false;
      state.mediaTypeData = {};
      state.systemNotesStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
    },
    resetRecordStatus: (state, action) => {
      state.addMediaStatus = null;
      state.addSuccessMsg = null;
    },
    getDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addMediaTypeStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.systemNotesStatus = null;
      state.isSystemNoteLoading = false;
      state.mediaTypePrintStatus = null;
    },
    resetData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.addMediaTypeStatus = null;
      state.isSystemNoteLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  postMediaTypeData,
  getMediaTypeData,
  fetchSuccess,
  fetchError,
  resetMessage,
  getDropDownData,
  postSystemNotesData,
  resetStatus,
  resetData,
  postMediaTypeAddData,
  fetchAddSuccess,
  resetRecordStatus,
  fetchNoteStart,
  getMediaTypeUsageData,
  setMediaTypePrintData,
  resetMediaUsagedata,
} = slice.actions;


export const fetchMediaTypeUsage = (name) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`integrationmedia/get/usageintegrationmedia/${name}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getMediaTypeUsageData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postMediaType = (values) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`integrationmedia/save/integrationmedia`, values)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(postMediaTypeAddData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postMediaTypeData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchMediaType = (mediaTypeId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`integrationmedia/find/${mediaTypeId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getMediaTypeData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const printMediaType = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`integrationmedia/print/mediatype`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPrintMediaType({dockey: data?.message}, data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};


export const postPrintMediaType = (payload, postMediaTypeData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`integrationmedia/generateurlprintmediatype`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(setMediaTypePrintData(postMediaTypeData));
          download(data.data);
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};


export const fetchDropdownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lookup/find/all/lookup`, {
      typeCode: [FILE_FORMATS],
    })
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getDropDownData(data.data));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`integrationmedia/save/mediatypenotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};
export const ResetAddRecord = () => {
  return (dispatch) => {
    dispatch(resetRecordStatus());
  };
};
